<div class="row">
    <div class="col-xl-6">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="my-card-title-with-tools">
                    <div class="title">
                        <span class="svg-icon svg-icon-primary svg-icon-2x mr-5">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M5,2 L19,2 C20.1045695,2 21,2.8954305 21,4 L21,6 C21,7.1045695 20.1045695,8 19,8 L5,8 C3.8954305,8 3,7.1045695 3,6 L3,4 C3,2.8954305 3.8954305,2 5,2 Z M11,4 C10.4477153,4 10,4.44771525 10,5 C10,5.55228475 10.4477153,6 11,6 L16,6 C16.5522847,6 17,5.55228475 17,5 C17,4.44771525 16.5522847,4 16,4 L11,4 Z M7,6 C7.55228475,6 8,5.55228475 8,5 C8,4.44771525 7.55228475,4 7,4 C6.44771525,4 6,4.44771525 6,5 C6,5.55228475 6.44771525,6 7,6 Z" fill="#000000" opacity="0.3"/>
                                    <path d="M5,9 L19,9 C20.1045695,9 21,9.8954305 21,11 L21,13 C21,14.1045695 20.1045695,15 19,15 L5,15 C3.8954305,15 3,14.1045695 3,13 L3,11 C3,9.8954305 3.8954305,9 5,9 Z M11,11 C10.4477153,11 10,11.4477153 10,12 C10,12.5522847 10.4477153,13 11,13 L16,13 C16.5522847,13 17,12.5522847 17,12 C17,11.4477153 16.5522847,11 16,11 L11,11 Z M7,13 C7.55228475,13 8,12.5522847 8,12 C8,11.4477153 7.55228475,11 7,11 C6.44771525,11 6,11.4477153 6,12 C6,12.5522847 6.44771525,13 7,13 Z" fill="#000000"/>
                                    <path d="M5,16 L19,16 C20.1045695,16 21,16.8954305 21,18 L21,20 C21,21.1045695 20.1045695,22 19,22 L5,22 C3.8954305,22 3,21.1045695 3,20 L3,18 C3,16.8954305 3.8954305,16 5,16 Z M11,18 C10.4477153,18 10,18.4477153 10,19 C10,19.5522847 10.4477153,20 11,20 L16,20 C16.5522847,20 17,19.5522847 17,19 C17,18.4477153 16.5522847,18 16,18 L11,18 Z M7,20 C7.55228475,20 8,19.5522847 8,19 C8,18.4477153 7.55228475,18 7,18 C6.44771525,18 6,18.4477153 6,19 C6,19.5522847 6.44771525,20 7,20 Z" fill="#000000"/>
                                </g>
                            </svg>
                        </span>
                        <h5>Websites</h5>
                    </div>
                </div>
                <mat-progress-bar mode="indeterminate" *ngIf="(loadingWebsites$ | async)"></mat-progress-bar>
                <div *ngIf="!(loadingWebsites$ | async) && !(hasWebsites$ | async)">No websites found!</div>
                <div *ngIf="!(loadingWebsites$ | async) && (hasWebsites$ | async)" class="table-responsive angular-bootstrap-table">
                    <table class="table text-center">
                        <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Active Promotion</th>
                            <th scope="col">Action</th>

                        </tr>
                        </thead>
                        <tbody>
                        <ng-container *ngFor="let website of websites$ | async">
                            <ng-container [ngTemplateOutlet]="WebsiteTemplate" [ngTemplateOutletContext]="{item: website}"></ng-container>
                        </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="my-card-title-with-tools">
                    <div class="title">
                        <span class="svg-icon svg-icon-primary svg-icon-2x mr-5">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M3.5,3 L5,3 L5,19.5 C5,20.3284271 4.32842712,21 3.5,21 L3.5,21 C2.67157288,21 2,20.3284271 2,19.5 L2,4.5 C2,3.67157288 2.67157288,3 3.5,3 Z" fill="#000000"/>
                                    <path d="M6.99987583,2.99995344 L19.754647,2.99999303 C20.3069317,2.99999474 20.7546456,3.44771138 20.7546439,3.99999613 C20.7546431,4.24703684 20.6631995,4.48533385 20.497938,4.66895776 L17.5,8 L20.4979317,11.3310353 C20.8673908,11.7415453 20.8341123,12.3738351 20.4236023,12.7432941 C20.2399776,12.9085564 20.0016794,13 19.7546376,13 L6.99987583,13 L6.99987583,2.99995344 Z" fill="#000000" opacity="0.3"/>
                                </g>
                            </svg>
                        </span>
                        <h5>Promotions</h5>
                    </div>
                    <div class="tools">
                        <button color="primary" mat-button (click)="editPromotion(null)">
                            Add
                        </button>
                    </div>
                </div>
                <mat-progress-bar mode="indeterminate" *ngIf="(loadingPromos$ | async)"></mat-progress-bar>
                <div *ngIf="!(loadingPromos$ | async) && !(hasPromos$ | async)">No promotions found!</div>
                <div *ngIf="!(loadingPromos$ | async) && (hasPromos$ | async)" class="table-responsive angular-bootstrap-table">
                    <table class="table text-center">
                        <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Categories</th>
                            <th scope="col">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <ng-container *ngFor="let promo of promosAll$ | async">
                            <ng-container [ngTemplateOutlet]="PromotionTemplate" [ngTemplateOutletContext]="{item: promo}"></ng-container>
                        </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #PromotionTemplate let-item="item">
    <tr>
        <td nowrap class="table-row">{{item.name}}</td>
        <td class="table-row">{{item.getCategoriesSummary()}}</td>
        <td nowrap class="table-row">
            <button mat-icon-button color="primary" (click)="editPromotion(item)">
                <mat-icon aria-label="Edit">edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="removePromotion(item)">
                <mat-icon aria-label="Delete">delete</mat-icon>
            </button>
        </td>
    </tr>
</ng-template>

<ng-template #WebsiteTemplate let-item="item">
    <tr>
        <td class="table-row">{{item.name}}</td>
        <td class="table-row">
            <mat-form-field>
                <mat-select placeholder="Promotion" [value]="item.linkedPromotion" (selectionChange)="updateWebsiteLinkedPromotion(item.id, $event.value)">
                    <mat-option *ngFor="let promotion of promosAll$ | async" [value]="promotion.id">
                        {{ promotion.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </td>
        <td class="table-row">
            <button *ngIf="item.linkedPromotion" mat-icon-button color="warn" (click)="unlinkPromo(item)">
                <mat-icon aria-label="Delete">link_off</mat-icon>
            </button>
        </td>
    </tr>
</ng-template>